import { useEffect, useState } from 'react';

export function isMobile() {
  if (typeof window !== 'undefined') {
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent#:~:text=In%20summary%2C%20we%20recommend%20looking%20for%20the%20string%20Mobi%20anywhere%20in%20the%20User%20Agent%20to%20detect%20a%20mobile%20device.
    return /Mobi/i.test(window.navigator.userAgent);
  }
  return false;
}

export function useIsMobile() {
  const [mobile, setMobile] = useState<boolean>();
  useEffect(() => {
    setMobile(isMobile());
  }, []);
  return mobile;
}
